import { Dispatch, createContext } from 'react'
import { State, Action } from './types'
import { reducer } from './reducer'
import { createStateHook, createDispatchHook, createContextHook, createProvider } from '../../factory'

export const initialState: State = {
  loadingRules: false,
  rules: undefined,
  ruleList: undefined,
  selectedRule: undefined
}

const stateContext = createContext<State | undefined>(undefined)
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined)

export const RulesProvider = createProvider(stateContext, dispatchContext, reducer, initialState)
export const useRulesState = createStateHook(stateContext)
export const useRulesDispatch = createDispatchHook(dispatchContext)
export const useRules = createContextHook(stateContext, dispatchContext)
